import React from 'react';

import { Container, NotTasks } from './styles';
import { Warning } from 'phosphor-react';

interface INotFoundRegisterProps {
  description?: string;
  subdescription?: string;
  emoji?: string;
  style?: React.CSSProperties;
}

const NotFoundRegister: React.FC<INotFoundRegisterProps> = ({ description, style, emoji = '😢', subdescription }) => {
  return (
    <Container style={style}>
      <NotTasks>
        <header>
          <div>
            <Warning size={40} weight='duotone' />
          </div>
          <h5>{description}</h5>
        </header>
        <main>
          <p>{subdescription || 'Comece a ultilizar a plataforma e novas notificações aparecerão aqui...'}</p>
        </main>
      </NotTasks>
    </Container>
  );
}

export default NotFoundRegister;